"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledColumnedDropdownTitle = void 0;
// packages
const react_1 = __importDefault(require("react"));
// styles
const DropdownTitle_styles_1 = require("./DropdownTitle.styles");
const Dropdown_styles_1 = require("./Dropdown.styles");
const StyledColumnedDropdownTitle = (props) => {
    const { columns = [] } = props;
    const columnsToShow = columns.map((column) => {
        let setWidth = 'auto';
        if (column.width) {
            setWidth = column.width.toString();
        }
        return (react_1.default.createElement(DropdownTitle_styles_1.StyledColumnedTitleLabel, { key: column.key, height: Dropdown_styles_1.ITEM_HEIGHT_TEXT, width: setWidth, paddingLeft: Dropdown_styles_1.ITEM_PADDING_LEFT },
            react_1.default.createElement(DropdownTitle_styles_1.StyledColumnedTitleText, { height: Dropdown_styles_1.ITEM_HEIGHT_TEXT, width: 'auto' }, column.label)));
    });
    return (react_1.default.createElement(DropdownTitle_styles_1.StyledTitleContainer, null,
        react_1.default.createElement(DropdownTitle_styles_1.StyledColumnedTitleElement, null, columnsToShow.map((i) => i))));
};
exports.StyledColumnedDropdownTitle = StyledColumnedDropdownTitle;
exports.default = exports.StyledColumnedDropdownTitle;
//# sourceMappingURL=ColumnedDropdownTitle.js.map